
$('body').on('click', '.app-message-close', function(){
    $('.app-message').removeClass('shown').fadeOut();
});
